import { GETWORKSPACEDETAILS_FAIL, GETWORKSPACEDETAILS_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const getWorkspaceDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GETWORKSPACEDETAILS_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case GETWORKSPACEDETAILS_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default getWorkspaceDetailsReducer;
